import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ReactJoyride, { ACTIONS } from 'react-joyride';

import { ORDERS_PAGE_COACHMARKS, StepLookup } from '../steps';
import { CoachmarkTooltip } from '../components/custom-tooltip';
import { useEnableV3Coachmarks } from '../../../feature-flags/hooks/use-enable-v3-coachmarks';
import { LocalStorageService } from '../../../services/local-storage-service';
import { useSegmentTracking } from '../hooks/use-segment-tracking';
import { COACHMARK_CLOSE, COACHMARK_NEXT, COACHMARK_OPEN } from '../../../constants/analytics-events';
import debounce from 'lodash.debounce';

export const Coachmark = ({ steps }) => {
  const isV3CoachmarksEnabled = useEnableV3Coachmarks();
  const activeSteps = useSelector((state) => StepLookup[steps].filter(({ shouldRender }) => shouldRender(state)));

  const segmentTrackOpen = debounce(useSegmentTracking(COACHMARK_OPEN), 200);
  const segmentTrackClose = debounce(useSegmentTracking(COACHMARK_CLOSE), 200);
  const segmentTrackNext = debounce(useSegmentTracking(COACHMARK_NEXT), 200);

  const handleJoyrideCallback = useCallback(
    ({ action, step }) => {
      const segmentActionLookup = {
        [ACTIONS.NEXT]: segmentTrackNext,
        [ACTIONS.START]: segmentTrackOpen,
        [ACTIONS.CLOSE]: segmentTrackClose,
      };
      const segmentTrackCallback = segmentActionLookup[action];
      if (segmentTrackCallback) {
        segmentTrackCallback();
      }
      if ([ACTIONS.CLOSE, ACTIONS.NEXT].includes(action)) {
        LocalStorageService.setItem(step.localStorageKey, true);
      }
    },
    [segmentTrackClose, segmentTrackNext, segmentTrackOpen],
  );

  if (!isV3CoachmarksEnabled) {
    return null;
  }

  return <ReactJoyride callback={handleJoyrideCallback} continuous steps={activeSteps} tooltipComponent={CoachmarkTooltip} />;
};

Coachmark.propTypes = {
  steps: PropTypes.oneOf([ORDERS_PAGE_COACHMARKS]).isRequired,
};
